import React, { Component } from "react"
import PropTypes from "prop-types"
import injectSheet from "react-jss"
import numeral from "numeral"
import { handleSelect } from "../utils"
import Button from "./Button"

const style = {
  label: {
    color: "#0E283D",
    fontFamily: "Fira Sans",
    fontSize: 16,
    marginTop: 2,
    marginRight: 28,
  },
  labelDevice: {
    extend: "label",
    marginRight: 0,
  },
  text: {
    color: "#5CA7DF",
    fontFamily: "Fira Sans",
    fontSize: 20,
    fontWeight: 600,
    marginTop: 6,
    cursor: "default",
  },
  form: {
    extend: "text",
    marginTop: 0,
    height: 20,
    width: 50,
    border: "none",
    outline: "none",
    cursor: "text",
    borderBottom: "1px dashed #5CA7DF",
    marginLeft: 10,
  },
  formDevices: {
    extend: "form",
    marginLeft: 10,
    width: 73,
  },
  boxForm: {
    display: "inline-flex",
    marginTop: 26,
    marginLeft: 20,
    marginRight: 39,
  },
}

class Form extends Component {
  constructor(props) {
    super(props)

    this.handleChange = this.handleChange.bind(this)
    this.addValue = this.addValue.bind(this)
    this.subValue = this.subValue.bind(this)
    this.submitAdd = this.submitAdd.bind(this)
    this.submitSub = this.submitSub.bind(this)
    this.submit = this.submit.bind(this)
    this.onPress = this.onPress.bind(this)
  }

  handleChange(event) {
    const { onChange } = this.props
    const bandwidth = Number(numeral(event.target.value).value())
    onChange(bandwidth)
  }

  submit(event) {
    event.preventDefault()
    const { onChange, value } = this.props
    const bandwidth = Number(value) + 1
    onChange(bandwidth)
  }

  submitAdd() {
    const { onChange, value } = this.props
    const bandwidth = Number(value) + 1
    onChange(bandwidth)
  }

  submitSub() {
    const { onChange, value } = this.props
    const bandwidth = Number(value) > 0 ? Number(value) - 1 : 0
    onChange(bandwidth)
  }

  onPress(event) {
    if (event.keyCode === 38) {
      return this.submitAdd()
    } else if (event.keyCode === 40) {
      return this.submitSub()
    }
    return this.handleChange(event)
  }

  addValue() {
    const { onChange, value } = this.props
    const bandwidth = Number(value) + 1
    onChange(bandwidth)
  }

  subValue() {
    const { onChange, value } = this.props
    const bandwidth = value > 0 ? value - 1 : 0
    onChange(bandwidth)
  }

  render() {
    const { classes, value, text } = this.props
    const box = value >= 10000 ? classes.formDevices : classes.form
    const label = value >= 10000 ? classes.labelDevice : classes.label
    const valueFormatted = numeral(value).format("0,0")

    return (
      <form
        className={classes.boxForm}
        onSubmit={this.submit}
        onKeyDown={this.onPress}
      >
        <Button onValueAdd={this.addValue} onValueSub={this.subValue} />
        <input
          onClick={handleSelect}
          className={box}
          type="text"
          value={valueFormatted}
          onChange={this.handleChange}
        />
        <span className={label}>{text}</span>
      </form>
    )
  }
}

Form.propTypes = {
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
}

export default injectSheet(style)(Form)
